import { useCustomerService } from '../customerService';
import { Container, PageContent } from './Common.styles';
import { BRANDING_KEY } from '~/components/branding/constants';
import PublicFooter from '~/components/branding/PublicFooter';
import useBranded from '~/components/branding/useBranded';

const PublicWrapper = ({ children }: React.PropsWithChildren) => {
  useCustomerService();
  const customBranding = useBranded(BRANDING_KEY.PUBLIC_CLASSNAME);

  return (
    <Container className={customBranding} color="$black">
      <PageContent>{children}</PageContent>
      <PublicFooter />
    </Container>
  );
};
export default PublicWrapper;
